import { useField } from 'formik';
import { TimeInput as TimeInputMantine } from '@mantine/dates';

// @ts-expect-error dumb
export const TimeInput = ({ label, ...props }) => {
  // @ts-expect-error dumb
  const [field, meta, helpers] = useField(props);

  const { value } = meta;
  const { setValue } = helpers;

  return (
    <TimeInputMantine
      label={label}
      value={value}
      onChange={(e) => setValue(e)}
      error={meta.touched && meta.error}
      {...props}
    />
  );
};
